import styled from 'styled-components';

const Page = styled.div`
  padding-top: 190px;
  padding-bottom: 50px;
  min-height: calc(100vh - 240px);
`;

export default Page;
